import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, Avatar } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import type { Customer } from '../types/types';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    overflowX: 'auto',
  },
  card: {
    marginBottom: theme.spacing(1),
    width: '100%',
    cursor: 'pointer'
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

interface Props {
  customers?: Customer[];
}

const CustomerList: FC<Props> = ({ customers }) => {
  const navigate = useNavigate();
  const { avatar, root, card } = useStyles();

  return (
    <div className={root}>
      {customers?.map((customer, index) => (
        <Card className={card} key={`customer${index}`}>
          <CardHeader
            avatar={
              <Avatar aria-label="name" className={avatar}>
                {`${customer.firstName ? customer.firstName[0]: ''}${customer.lastName? customer.lastName[0] : ''}`}
              </Avatar>
            }
            title={`${customer.firstName} ${customer.lastName}`}
            subheader={customer.email}
            onClick={() => navigate(`/customers/details/${customer.id}`)}
          />
        </Card>
      ))}
    </div>
  );
};

export default CustomerList;